var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	13613: () => (loadSingletonVersion("default", "rxjs", false, [,[1,7,4,0],[1,6,5,3],1], () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(7691), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(7691))))))),
	32409: () => (loadSingletonVersion("default", "rxjs/operators", false, [,[1,7,4,0],[1,6,5,3],1], () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(3895), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(13895))))))),
	55399: () => (loadSingletonVersion("default", "@angular/core", false, [1,19,0,0], () => (Promise.all([__webpack_require__.e(2409), __webpack_require__.e(9285)]).then(() => (() => (__webpack_require__(89285))))))),
	57459: () => (loadSingletonVersion("default", "@angular/common", false, [,[1,20,0,0],[1,19,0,0],1], () => (Promise.all([__webpack_require__.e(1163), __webpack_require__.e(9111)]).then(() => (() => (__webpack_require__(31163))))))),
	16851: () => (loadSingletonVersion("default", "@angular/common", false, [4,19,2,21], () => (Promise.all([__webpack_require__.e(1163), __webpack_require__.e(9111)]).then(() => (() => (__webpack_require__(31163))))))),
	20661: () => (loadSingletonVersion("default", "@angular/common/http", false, [4,19,2,21], () => (Promise.all([__webpack_require__.e(1303), __webpack_require__.e(1492)]).then(() => (() => (__webpack_require__(31303))))))),
	21635: () => (loadSingletonVersion("default", "rxjs/operators", false, [,[1,7,0,0],[1,6,0,0],1], () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(3895)]).then(() => (() => (__webpack_require__(13895))))))),
	25362: () => (loadSingletonVersion("default", "@angular/material/snack-bar", false, [4,19,2,19], () => (__webpack_require__.e(6205).then(() => (() => (__webpack_require__(56205))))))),
	40825: () => (loadSingletonVersion("default", "@angular/common", false, [1,19,0,0], () => (__webpack_require__.e(1163).then(() => (() => (__webpack_require__(31163))))))),
	40885: () => (loadSingletonVersion("default", "@angular/common", false, [0,12,0,0], () => (__webpack_require__.e(1163).then(() => (() => (__webpack_require__(31163))))))),
	42800: () => (loadSingletonVersion("default", "@angular/material/dialog", false, [4,19,2,19], () => (__webpack_require__.e(152).then(() => (() => (__webpack_require__(152))))))),
	47767: () => (loadSingletonVersion("default", "@angular/router", false, [4,19,2,21], () => (__webpack_require__.e(3092).then(() => (() => (__webpack_require__(33092))))))),
	48840: () => (loadSingletonVersion("default", "rxjs/operators", false, [4,6,6,7], () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(3895)]).then(() => (() => (__webpack_require__(13895))))))),
	56840: () => (loadSingletonVersion("default", "@angular/common", false, [,[1,19],[-1,19],1,[0,12],2], () => (__webpack_require__.e(1163).then(() => (() => (__webpack_require__(31163))))))),
	57550: () => (loadSingletonVersion("default", "rxjs/operators", false, [0,6,6,3], () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(3895)]).then(() => (() => (__webpack_require__(13895))))))),
	58828: () => (loadSingletonVersion("default", "rxjs", false, [4,6,6,7], () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(7691)]).then(() => (() => (__webpack_require__(7691))))))),
	59803: () => (loadSingletonVersion("default", "rxjs", false, [,[1,7,0,0],[1,6,0,0],1], () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(7691)]).then(() => (() => (__webpack_require__(7691))))))),
	61983: () => (loadSingletonVersion("default", "@angular/common", false, [0,14,0,0], () => (__webpack_require__.e(1163).then(() => (() => (__webpack_require__(31163))))))),
	66993: () => (loadSingletonVersion("default", "@angular/router", false, [0,12,0,0], () => (__webpack_require__.e(3092).then(() => (() => (__webpack_require__(33092))))))),
	72066: () => (loadSingletonVersion("default", "@angular/common", false, [0,19,0,0], () => (__webpack_require__.e(1163).then(() => (() => (__webpack_require__(31163))))))),
	75722: () => (loadSingletonVersion("default", "rxjs", false, [0,6,6,3], () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(7691)]).then(() => (() => (__webpack_require__(7691))))))),
	79208: () => (loadSingletonVersion("default", "@angular/common/http", false, [0,19,0,0], () => (__webpack_require__.e(1303).then(() => (() => (__webpack_require__(31303))))))),
	86154: () => (loadSingletonVersion("default", "@ngx-translate/core", false, [4,14,0,0], () => (__webpack_require__.e(7376).then(() => (() => (__webpack_require__(97376))))))),
	89276: () => (loadSingletonVersion("default", "@angular/common", false, [0,13,0,0], () => (__webpack_require__.e(1163).then(() => (() => (__webpack_require__(31163)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"189": [
		16851,
		20661
	],
	"1697": [
		57459
	],
	"2409": [
		32409
	],
	"3613": [
		13613
	],
	"5399": [
		55399
	],
	"5855": [
		21635,
		25362,
		40825,
		40885,
		42800,
		47767,
		48840,
		56840,
		57550,
		58828,
		59803,
		61983,
		66993,
		72066,
		75722,
		79208,
		86154,
		89276
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}